import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

interface IStoresForm_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IStoresForm_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: string;
  GoBack_dummy: string;
  SelectA_Stores: any[];
  SelectA_Stores_dummy: any[];
  CityGet: any[];
  CityGet_dummy: any[];
  DistrictGet: any[];
  DistrictGet_dummy: any[];
  SaveRecord_1: number;
  SaveRecord_1_dummy: number;
  wfScreenName: string;
}

export class StoresForm_ScreenBase extends React.PureComponent<IStoresForm_ScreenProps, any> {
  storesform_907762_value_kuikaSelectBoxRef: React.RefObject<any>;
  storesform_950421_value_kuikaSelectBoxRef: React.RefObject<any>;
  ml = [
    {
      Id: "4f05fda5-b043-9e86-8437-71ea4357a314",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: []
    },
    { Id: "7a8fc238-9831-4128-a954-0cdac59f257a", Name: "en_US", ShortName: "English", LanguagePhrases: [] },
    {
      Id: "eae33ae9-5280-4b9d-9fa9-7360844315e5",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 796540, PropertyName: "value", Value: "Mağaza Tanımlama" },
        { Id: 8664867, PropertyName: "value", Value: "Mağaza Kodu" },
        { Id: 8577310, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 8065368, PropertyName: "value", Value: "Mağaza Adı" },
        { Id: 5802109, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 7103811, PropertyName: "value", Value: "İl" },
        { Id: 1903387, PropertyName: "value", Value: "İlçe" },
        { Id: 8176138, PropertyName: "value", Value: "Cari Kod" },
        { Id: 2244970, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 2198234, PropertyName: "value", Value: "Email" },
        { Id: 6584646, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 2769025, PropertyName: "value", Value: "Adres" },
        { Id: 9544, PropertyName: "label", Value: "Kaydet" }
      ]
    }
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.storesform_8577310_value_kuikaTextInputRef = React.createRef();
    this.storesform_5802109_value_kuikaTextInputRef = React.createRef();
    this.storesform_907762_value_kuikaSelectBoxRef = React.createRef();
    this.storesform_950421_value_kuikaSelectBoxRef = React.createRef();
    this.storesform_2244970_value_kuikaTextInputRef = React.createRef();
    this.storesform_6584646_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      SelectA_Stores: [],
      CityGet: [],
      DistrictGet: [],
      SaveRecord_1: false,
      wfScreenName: ""
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("storesform", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.StoresFormPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("storesform", "");
  }

  componentWillUnmount() {}

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["SSHAdmin"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (!permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText = "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText = "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText = "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText = "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("storesform", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.StoresFormPageInit();
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      storesform_8577310_value: this.state.SelectA_Stores?.at?.(0)?.storeCode ?? undefined,
      storesform_5802109_value: this.state.SelectA_Stores?.at?.(0)?.storeName ?? undefined,
      storesform_907762_value: this.state.SelectA_Stores?.at?.(0)?.city ?? undefined,
      storesform_950421_value: this.state.SelectA_Stores?.at?.(0)?.district ?? undefined,
      storesform_2244970_value: this.state.SelectA_Stores?.at?.(0)?.accountCode ?? undefined,
      storesform_6584646_value: this.state.SelectA_Stores?.at?.(0)?.email ?? undefined,
      storesform_998773_value: this.state.SelectA_Stores?.at?.(0)?.storeAdress ?? undefined
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: []
        }
      ]);
    }
  };

  StoresFormPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(this.props.screenInputs.Id ?? this.props.screenInputs.id, "Guid")
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "StoresForm/StoresFormPageInit", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectA_Stores = result?.data.selectA_Stores;
    formVars.storesform_8577310_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectA_Stores !== undefined
        ? stateVars.SelectA_Stores?.length > 0
          ? stateVars.SelectA_Stores[0].storeCode
          : null
        : this.state.SelectA_Stores?.length > 0
        ? this.state.SelectA_Stores[0].storeCode
        : null
    );
    formVars.storesform_5802109_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectA_Stores !== undefined
        ? stateVars.SelectA_Stores?.length > 0
          ? stateVars.SelectA_Stores[0].storeName
          : null
        : this.state.SelectA_Stores?.length > 0
        ? this.state.SelectA_Stores[0].storeName
        : null
    );
    formVars.storesform_907762_value =
      stateVars.SelectA_Stores !== undefined
        ? stateVars.SelectA_Stores?.length > 0
          ? stateVars.SelectA_Stores[0].city
          : null
        : this.state.SelectA_Stores?.length > 0
        ? this.state.SelectA_Stores[0].city
        : null;
    formVars.storesform_907762_options = stateVars.CityGet;
    formVars.storesform_950421_value =
      stateVars.SelectA_Stores !== undefined
        ? stateVars.SelectA_Stores?.length > 0
          ? stateVars.SelectA_Stores[0].district
          : null
        : this.state.SelectA_Stores?.length > 0
        ? this.state.SelectA_Stores[0].district
        : null;
    formVars.storesform_2244970_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectA_Stores !== undefined
        ? stateVars.SelectA_Stores?.length > 0
          ? stateVars.SelectA_Stores[0].accountCode
          : null
        : this.state.SelectA_Stores?.length > 0
        ? this.state.SelectA_Stores[0].accountCode
        : null
    );
    formVars.storesform_6584646_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectA_Stores !== undefined
        ? stateVars.SelectA_Stores?.length > 0
          ? stateVars.SelectA_Stores[0].email
          : null
        : this.state.SelectA_Stores?.length > 0
        ? this.state.SelectA_Stores[0].email
        : null
    );
    formVars.storesform_998773_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectA_Stores !== undefined
        ? stateVars.SelectA_Stores?.length > 0
          ? stateVars.SelectA_Stores[0].storeAdress
          : null
        : this.state.SelectA_Stores?.length > 0
        ? this.state.SelectA_Stores[0].storeAdress
        : null
    );
    stateVars.CityGet = result?.data.cityGet;

    formVars.storesform_907762_value =
      stateVars.SelectA_Stores !== undefined
        ? stateVars.SelectA_Stores?.length > 0
          ? stateVars.SelectA_Stores[0].city
          : null
        : this.state.SelectA_Stores?.length > 0
        ? this.state.SelectA_Stores[0].city
        : null;
    formVars.storesform_907762_options = stateVars.CityGet;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.StoresFormPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StoresFormPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    let localVar = {
      City_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectA_Stores !== undefined
            ? stateVars.SelectA_Stores?.length > 0
              ? stateVars.SelectA_Stores[0].city
              : null
            : this.state.SelectA_Stores?.length > 0
            ? this.state.SelectA_Stores[0].city
            : null
        ),
        "string"
      )
    };

    if (
      ReactSystemFunctions.isNotEmpty(
        stateVars.SelectA_Stores !== undefined
          ? stateVars.SelectA_Stores?.length > 0
            ? stateVars.SelectA_Stores[0].storeName
            : null
          : this.state.SelectA_Stores?.length > 0
          ? this.state.SelectA_Stores[0].storeName
          : null,
        null
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(this, "StoresForm/StoresFormPageInit1_", localVar);
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.DistrictGet = result?.data.districtGet;

      formVars.storesform_950421_options = stateVars.DistrictGet;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.StoresFormPageInit2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.StoresFormPageInit2_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StoresFormPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    formVars.storesform_8577310_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectA_Stores !== undefined
        ? stateVars.SelectA_Stores?.length > 0
          ? stateVars.SelectA_Stores[0].storeCode
          : null
        : this.state.SelectA_Stores?.length > 0
        ? this.state.SelectA_Stores[0].storeCode
        : null
    );

    formVars.storesform_5802109_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectA_Stores !== undefined
        ? stateVars.SelectA_Stores?.length > 0
          ? stateVars.SelectA_Stores[0].storeName
          : null
        : this.state.SelectA_Stores?.length > 0
        ? this.state.SelectA_Stores[0].storeName
        : null
    );

    formVars.storesform_907762_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectA_Stores !== undefined
        ? stateVars.SelectA_Stores?.length > 0
          ? stateVars.SelectA_Stores[0].city
          : null
        : this.state.SelectA_Stores?.length > 0
        ? this.state.SelectA_Stores[0].city
        : null
    );

    stateVars.dataSource_907762 = this.state.CityGet;
    stateVars.dataSource_907762 = this.state.CityGet;
    formVars.storesform_950421_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectA_Stores !== undefined
        ? stateVars.SelectA_Stores?.length > 0
          ? stateVars.SelectA_Stores[0].district
          : null
        : this.state.SelectA_Stores?.length > 0
        ? this.state.SelectA_Stores[0].district
        : null
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.StoresFormPageInit3_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  StoresFormPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        stateVars.SelectA_Stores !== undefined
          ? stateVars.SelectA_Stores?.length > 0
            ? stateVars.SelectA_Stores[0].storeName
            : null
          : this.state.SelectA_Stores?.length > 0
          ? this.state.SelectA_Stores[0].storeName
          : null,
        null
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.StoresFormPageInit4_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.StoresFormPageInit4_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  StoresFormPageInit4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        stateVars.SelectA_Stores !== undefined
          ? stateVars.SelectA_Stores?.length > 0
            ? stateVars.SelectA_Stores[0].storeName
            : null
          : this.state.SelectA_Stores?.length > 0
          ? this.state.SelectA_Stores[0].storeName
          : null,
        null
      )
    ) {
      stateVars.dataSource_950421 = this.state.DistrictGet;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.StoresFormPageInit5_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.StoresFormPageInit5_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  StoresFormPageInit5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        stateVars.SelectA_Stores !== undefined
          ? stateVars.SelectA_Stores?.length > 0
            ? stateVars.SelectA_Stores[0].storeName
            : null
          : this.state.SelectA_Stores?.length > 0
          ? this.state.SelectA_Stores[0].storeName
          : null,
        null
      )
    ) {
      stateVars.dataSource_950421 = this.state.DistrictGet;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.StoresFormPageInit6_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.StoresFormPageInit6_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  StoresFormPageInit6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    formVars.storesform_2244970_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectA_Stores !== undefined
        ? stateVars.SelectA_Stores?.length > 0
          ? stateVars.SelectA_Stores[0].accountCode
          : null
        : this.state.SelectA_Stores?.length > 0
        ? this.state.SelectA_Stores[0].accountCode
        : null
    );

    formVars.storesform_6584646_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectA_Stores !== undefined
        ? stateVars.SelectA_Stores?.length > 0
          ? stateVars.SelectA_Stores[0].email
          : null
        : this.state.SelectA_Stores?.length > 0
        ? this.state.SelectA_Stores[0].email
        : null
    );

    formVars.storesform_998773_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectA_Stores !== undefined
        ? stateVars.SelectA_Stores?.length > 0
          ? stateVars.SelectA_Stores[0].storeAdress
          : null
        : this.state.SelectA_Stores?.length > 0
        ? this.state.SelectA_Stores[0].storeAdress
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  StoresFormComponent_968274_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  StoresFormComponent_907762_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      City_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "storesform_907762_value", "value", "CityGet", "cityName", "cityName")
        ),
        "string"
      )
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "StoresForm/StoresFormComponent_907762_onChange", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.DistrictGet = result?.data.districtGet;

    formVars.storesform_950421_options = stateVars.DistrictGet;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.StoresFormComponent_907762_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StoresFormComponent_907762_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    stateVars.dataSource_950421 = this.state.DistrictGet;
    stateVars.dataSource_950421 = this.state.DistrictGet;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  StoresFormComponent_907762_onSelect = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      City_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "storesform_907762_value", "value", "CityGet", "cityName", "cityName")
        ),
        "string"
      )
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "StoresForm/StoresFormComponent_907762_onSelect", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.DistrictGet = result?.data.districtGet;

    formVars.storesform_950421_options = stateVars.DistrictGet;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.StoresFormComponent_907762_onSelect1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StoresFormComponent_907762_onSelect1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    stateVars.dataSource_950421 = this.state.DistrictGet;
    stateVars.dataSource_950421 = this.state.DistrictGet;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  StoresFormComponent_9544_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(this.props.screenInputs.Id ?? this.props.screenInputs.id, "Guid"),
      AccountCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "storesform_2244970_value", "value", "", "", "")
        ),
        "string"
      ),
      City_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "storesform_907762_value", "value", "CityGet", "cityName", "cityName")
        ),
        "string"
      ),
      District_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "storesform_950421_value",
            "value",
            "DistrictGet",
            "districtName",
            "districtName"
          )
        ),
        "string"
      ),
      Email_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "storesform_6584646_value", "value", "", "", "")
        ),
        "string"
      ),
      StoreAdress_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "storesform_998773_value", "value", "", "", "")
        ),
        "string"
      ),
      StoreCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "storesform_8577310_value", "value", "", "", "")
        ),
        "string"
      ),
      StoreName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "storesform_5802109_value", "value", "", "", "")
        ),
        "string"
      )
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "StoresForm/StoresFormComponent_9544_onClick", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SaveRecord_1 = result?.data.saveRecord_1;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.StoresFormComponent_9544_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StoresFormComponent_9544_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }

  getWfPageComponent = () => {
    return ReactSystemFunctions.getWfPageComponent(this, this.state.wfScreenName);
  };
}
